import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const FIELDS = [
  ["hospital_name", "Hospital / Clinic Name *", "col-span-2"],
  ["contact_person", "Kind Attn (Doctor / Procurement)", ""],
  ["phone_number", "Phone / WhatsApp", ""],
  ["address", "Address", "col-span-2"],
  ["city", "City", ""],
  ["state", "State", ""],
  ["gstin", "Customer GSTIN (optional)", "col-span-2"],
];

export const CustomerSection = ({ customer, onChange, clients, disabled, onPickClient }) => (
  <div className="space-y-3">
    {!disabled && clients.length > 0 && (
      <Select onValueChange={onPickClient}>
        <SelectTrigger className="bg-slate-50" data-testid="quote-client-select"><SelectValue placeholder="Fill from saved client (optional)" /></SelectTrigger>
        <SelectContent className="bg-white">{clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.hospital_name}</SelectItem>)}</SelectContent>
      </Select>
    )}
    <div className="grid grid-cols-2 gap-3">
      {FIELDS.map(([k, label, cls]) => (
        <div key={k} className={cls}>
          <Label className="text-xs">{label}</Label>
          <Input value={customer[k] || ""} disabled={disabled} onChange={(e) => onChange({ ...customer, [k]: e.target.value })} data-testid={`quote-customer-${k}`} />
        </div>
      ))}
    </div>
  </div>
);
